/** @jsxImportSource @emotion/react */
import { Flex, LoadingIcon } from "basis";
import { useCardTempLock } from "./hooks";
import { LockUnlockCard } from "./LockUnlockCard";
import { LockUnlockUnavailable } from "./LockUnlockUnavailable";
import { getImageForProduct, ProductCode } from "./utils";

export type TemporaryLockUnlockCardProps = {
  token: string;
  cardEndsWith: string;
  cardName: string;
  productCode: string;
};

export const TemporaryLockUnlockCard = ({
  token,
  productCode,
  cardName,
  cardEndsWith,
}: TemporaryLockUnlockCardProps) => {
  const { isLoading, isError } = useCardTempLock(token);
  const imageFilename = getImageForProduct(productCode as ProductCode);

  if (isLoading) {
    return (
      <Flex
        height="200"
        placeItems="center"
        testId="temporarily-lock-card-page-loading"
      >
        <LoadingIcon size="medium" />
      </Flex>
    );
  }

  if (isError) {
    return (
      <LockUnlockUnavailable
        cardName={cardName}
        cardEndsWith={cardEndsWith}
        isFraudLocked={false}
      />
    );
  }

  return (
    <LockUnlockCard
      imageFilename={imageFilename}
      token={token}
      cardName={cardName}
      cardEndsWith={cardEndsWith}
    />
  );
};
